import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Dashboard from "../pages/Dashboard";

const MainLayout = ({ page }: { page?: React.ReactNode }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  useEffect(() => {
    const handleLoading = () => {
      const loadElement = document.getElementById("load");
      const contentsElement = document.getElementById("contents");

      if (document.readyState === "interactive") {
        if (contentsElement) {
          contentsElement.style.visibility = "hidden";
        }
      } else if (document.readyState === "complete") {
        setTimeout(() => {
          if (loadElement) {
            loadElement.style.display = "none";
          }
          if (contentsElement) {
            contentsElement.style.visibility = "visible";
          }
        }, 1000);
      }
    };

    document.onreadystatechange = handleLoading;

    return () => {
      document.onreadystatechange = null;
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div>
      <div id="load"></div>
      <div
        id="wrapper"
        className={`forced ${sidebarCollapsed ? "enlarged" : ""}`}
      >
        <Navbar onToggleSidebar={toggleSidebar} />
        <Sidebar />
        <div id="contents" className="content-page">
          <div className="content">{page || <Dashboard />}</div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
